import { STATUS_CARD, HAN_THE_OPTIONS } from "assets/constants/card-types";
import { FIELD_TYPE } from "types/enums"
import { ColumnsEdit } from "types/models/column-table-edit";
const {INPUT, DATE, SELECT, AUTO_COMPLETE, CURRENCY, DATE_ON, NUMBER, CHECKBOX, RADIO, NORMAL_CHECKBOX} = FIELD_TYPE;

const cssProps = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 8, xl: 8},
};

const cssProps2 = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
}

const inputFields = (dmKhoa, dmTrangThai, nhomDvkt, loaiDvkt) => {
  return [
  {
    type: INPUT,
    name: "id",
    label: "Mã",
    disabled: true,
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "tenDichVu",
    label: "Tên dịch vụ",
    rules:[
      {required: true, message: "Tên dịch vụ là bắt buộc!"},
    ],
    allowClear: true,
    ...cssProps
  },
  {
    type: CURRENCY,
    name: "donGia",
    label: "Giá BV",
    rules:[
      {required: true, message: "Giá bảo hiểm là bắt buộc!"},
    ],
    allowClear: true,
    ...cssProps
  },
  {
    type: CURRENCY,
    name: "bhChiTra",
    label: "Giá BHYT",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "moTa",
    label: "Mô tả",
    allowClear: true,
    ...cssProps
  },
  // {
  //   type: DATE,
  //   name: "ngayCapNhat",
  //   label: "Ngày cập nhật",
  //   disabled: true,
  //   ...cssProps
  // },
  {
    type: SELECT,
    name: "trangThai",
    label: "Trạng thái",
    rules:[
      {required: true, message: "Trạng thái là bắt buộc!"},
    ],
    allowClear: true,
    options: dmTrangThai.map(it => ({value: it.id, label: it.tenTTDichVuKyThuat})),
    ...cssProps
  },
  {
    type: SELECT,
    name: "idNhomDichVu",
    label: "Nhóm",
    rules:[
      {required: true, message: "Nhóm là bắt buộc!"},
    ],
    allowClear: true,
    options: nhomDvkt.map(it => ({value: it.id, label: it.tenNhomDichVu})),
    ...cssProps
  },
  {
    type: SELECT,
    name: "phanLoai",
    label: "Phân loại",
    allowClear: true,
    options: loaiDvkt.map(it => ({value: it.id, label: it.tenLoaiDichVuKyThuat})),
    ...cssProps
  },
  {
    type: SELECT,
    name: "khoa",
    label: "Khoa",
    allowClear: true,
    options: dmKhoa.map(it => ({value: it.id, label: it.tenPhongBan})),
    ...cssProps
  },
  {
    type: INPUT,
    name: "sttBYT",
    label: "STT_BYT",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "sttChuong",
    label: "STT_Chuong",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "chuong",
    label: "Chương",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "maTT4321",
    label: "Mã TT 43,21",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "phanLoaiPTTT",
    label: "Phân loại PTTT",
    allowClear: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "soLuong",
    label: "Số lượng",
    rules:[
      {required: true, message: "Số lượng là bắt buộc!"},
    ],
    allowClear: true,
    ...cssProps
  },
  {
    type: NORMAL_CHECKBOX,
    name: "coBaoHiem",
    label: "Có bảo hiểm",
    valuePropName: "checked",
    ...cssProps
  },
  {
    type: NORMAL_CHECKBOX,
    name: "bhNgoaiTru",
    label: "BH ngoại trú",
    valuePropName: "checked",
    ...cssProps
  },
  {
    type: NORMAL_CHECKBOX,
    name: "bhNoiTru",
    label: "BH nội trú",
    valuePropName: "checked",
    ...cssProps
  },
  {
    type: NORMAL_CHECKBOX,
    label: "Cần tư vấn",
    name: "canTuVan",
    valuePropName: "checked",
    ...cssProps,
  },
  {
    type: NORMAL_CHECKBOX,
    label: "Hiển thị lên bảng kê",
    name: "hienThiBangKe",
    valuePropName: "checked",
    ...cssProps,
  },
  {
    type: INPUT,
    name: "idBHYT",
    label: "Mã BHYT",
    allowClear: true,
    ...cssProps
  }
]}

export {
  inputFields
}